import axios from 'axios'
import { headersTokenConfig } from '../config/HeaderToken'

class Worker {
  list(page, limit, search) {
    const endPoint = `/workers?page=${page}&limit=${limit}`
    let url = process.env.REACT_APP_API_URL_V1 + endPoint

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`
    }

    return axios.get(url, headersTokenConfig)
  }

  bpjsHistory(id, year) {
    const params = {
      year: year,
    };

    const endPoint = `/bpjs/${id}/history?` + new URLSearchParams(params).toString();
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  deposit(id, payload) {
    const endPoint = `/bpjs/${id}/deposit`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint

    return axios.put(url, payload, headersTokenConfig)
  }

  bpjsUpdate(id, payload) {
    const endPoint = `/bpjs/${id}/pay`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint

    return axios.put(url, payload, headersTokenConfig)
  }
}

export default new Worker()
